import React from "react";

// eslint-disable-next-line import/prefer-default-export
export const Moisturizer = (): React.ReactNode => (
  <svg
    viewBox="0 0 24 24"
    width="20px"
    height="20px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Cap */}
    <rect x="9" y="2" width="6" height="3" rx="1" fill="currentColor" />

    {/* Bottle body */}
    <rect x="7" y="5" width="10" height="16" rx="3" fill="currentColor" />

    {/* Label (optional softer detail) */}
    <rect x="9" y="9" width="6" height="6" rx="2" fill="white" />

    {/* Droplet icon */}
    <path
      d="M12 10.5C10.8 12 10 13 10 14.2C10 15.7 11.1 17 12 17C12.9 17 14 15.7 14 14.2C14 13 13.2 12 12 10.5Z"
      fill="currentColor"
    />
  </svg>
);
